import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { Form, Spin } from 'antd';
import {
  EditOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import { ClubUser } from '../../models/clubUser';
import { getPagesAndBooksCountByUserId } from '../../service/bookcase';
import { getUser } from '../../service/user';
import { useUserStore } from '../../store/useUser';
import UserImage from '../UserImage/UserImage';

import styles from './Member.module.scss';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';
import { ucs2 } from 'punycode';

const BooksReader = ({ userId }) => {
  const { data: count, isFetching: isFetchingPages } = useQuery(
    ['pageBook', userId],
    () => getPagesAndBooksCountByUserId(userId),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false, enabled: !!userId },
  );

  return <>{count?.books} livros lidos</>
}

interface MemberProxyProps {
  member: ClubUser;
  editable: boolean;
  onClick?: (user: ClubUser) => void;
  refetch?: () => void;
}

const MemberComponent = ({ editable, member, onClick }: MemberProxyProps) => {
  const navigate = useNavigate()

  const { data: user, isFetching } = useQuery(
    ['member', 'user', member.userId],
    () => getUser(member.userId),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false, enabled: !!member?.userId },
  );

  let userState: string = '';

  const isMember = !!member && !!member?.wasAccepted && !member?.outClub && !member?.isKickedOut
  const isNotAccepted = !member?.wasAccepted
  const isOut = !!member?.outClub
  const userWasKicked = !!member?.isKickedOut
  const userIsCreator = !!member?.isCreator
  const userIsMediator = !!member?.isMediator && !member?.outClub

  userState = userIsCreator 
    ? "Criador" 
    : userWasKicked
      ? "Expulso"
        : userIsMediator
          ? "Mediador"
          : isMember 
            ? "Participando"
              : isNotAccepted
                ? "Ainda não foi aceito"
                : isOut 
                  ? "Saiu" 
                  : ''

  if (isFetching) return <Spin spinning={isFetching} />

  return (
    <div className={styles.container}>
      <div onClick={() => navigate(`/user/${user.id}`)} className={styles.imageContainer}>
        <UserImage path={user?.pathPhoto} name={user?.nick || user?.fullname} />
      </div>
      <div className={styles.informationContainer}>
        <h2>{user?.fullname}</h2>
        <BooksReader
          userId={user?.id}
        />
        <h2><strong>{userState}</strong></h2>
      </div>
      {
        editable &&
          <Button 
            style={styles.button}
            onClick={(ev) => {
              onClick && onClick(member);
          }}>
            <Icon icon='edit' />
          </Button>
      }
    </div>
  )
}

export { MemberComponent as Member };
